import React, { useEffect } from 'react';
import Privacy from '../components/Pages/Privacy/Privacy';
import Header from '../components/Layout/Header/Header';
import Footer from '../components/Layout/Footer/Footer';
import FloatingBackground from '../components/Common/FloatingBackground/FloatingBackground';
import SEO from '../components/SEO';
import { useScrollState } from '../stores/scrollStore';

const PrivacyPage: React.FC = () => {
  const { isScrolled, scrollProgress, throttledUpdateScrollState } = useScrollState();

  useEffect(() => {
    // Use throttled scroll handler for native scrolling
    const handleScroll = () => {
      throttledUpdateScrollState(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [throttledUpdateScrollState]);

  return (
    <>
      <SEO 
        title="Privacy Policy | Cinquity"
        description="Cinquity's privacy policy outlines how we collect, use, and protect your personal information when using our AI-driven eCOA platform for clinical trials."
        keywords="privacy policy, data protection, Cinquity privacy, clinical trial data privacy, healthcare data security"
      />
      <Header isScrolled={isScrolled} scrollProgress={scrollProgress} />
      <div>
        <div className="legal-page-container" style={{ position: 'relative', zIndex: 1 }}>
          <FloatingBackground />
          <Privacy />
        </div>
        <Footer />
      </div>
    </>
  );
};

export default PrivacyPage;
